import { makeVar } from "@apollo/client";

export const activePayeeAccountIdVar = makeVar(localStorage.getItem("activePayeeAccountId"));
